module.exports = __webpack_public_path__ + "media/thirdSection/1-b4cd272c.png";